module.exports = __webpack_public_path__ + "img/log-disabled.b13553c4.svg";